import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Loader from "../../library/common/Loader";
import SequenceRainfallData from "../component/sequenceRainfallData";
import * as sequenceLandingAction from "../../redux/actions/sequenceLandingAction";

const SequenceRainfallContainer = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const projectId = location?.state?.id;
  const projectNumber = location?.state?.projectNumber;
  const projectName = location?.state?.projectName;
  const clientName = location?.state?.clientname;

  const rainfallData = useSelector((state) => state.sequenceLandingRainfall);

  const getSequenceRainfallData = (data) => {
    dispatch(sequenceLandingAction.getSequenceLandingRainfallData(data));
  };

  return (
    <>
      {rainfallData?.isLoading && <Loader />}
      <SequenceRainfallData
        rainfallData={rainfallData}
        getSequenceRainfallData={getSequenceRainfallData}
        projectId={projectId}
        clientName={clientName}
        projectName={projectName}
        projectNumber={projectNumber}
      />
    </>
  );
};

export default SequenceRainfallContainer;
